interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="rounded-lg bg-background-100 border border-background-200 px-6 py-16 flex flex-col items-center text-center">
      <span className="w-14 h-14 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center mb-4">
        <i className="ri-file-search-line text-2xl"></i>
      </span>
      <h3 className="font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">{description}</p>
      <div className="mt-6 flex flex-col sm:flex-row items-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && secondaryTo && (
          <a
            href={secondaryTo}
            className="px-5 py-2.5 rounded-md bg-background-50 border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            {secondaryLabel}
          </a>
        )}
      </div>
    </div>
  );
}